import { dictionary as dictionary_en } from './en/index.js';
import { dictionary as dictionary_ca } from './en/index.js';
import { dictionary as dictionary_de } from './en/index.js';
import { dictionary as dictionary_es } from './en/index.js';
import { dictionary as dictionary_fr } from './en/index.js';
import { dictionary as dictionary_it } from './en/index.js';
import { dictionary as dictionary_nl } from './en/index.js';
import { dictionary as dictionary_pt } from './en/index.js';
import { addToDictionary } from '../../../../i18n/index.js';
const dictionaries = {
    en: dictionary_en,
    ca: dictionary_ca,
    de: dictionary_de,
    es: dictionary_es,
    fr: dictionary_fr,
    it: dictionary_it,
    nl: dictionary_nl,
    pt: dictionary_pt,
};
Object.entries(dictionaries).forEach(entry => {
    const dictionary = addToDictionary(entry[0], entry[1]);
});
